import logo from 'assets/images/ny-logo-sparebank1.png';
import { Box, Image } from 'grommet';
import useResponsive from 'hooks/useResponsive';
import React from 'react';

const SponsorRow = () => {
  const { isMobile } = useResponsive();
  return (
    <Box
      align="center"
      justify="center"
      direction={isMobile ? 'column' : 'row'}
      gap="medium"
      background="#DBEFF4"
      pad="12px"
    >
      <Image
        style={{ height: '100px', maxWidth: '100%' }}
        fit="contain"
        src={logo}
      />
    </Box>
  );
};

export default SponsorRow;
